import React from 'react';

export function CssYt() {
  const videos = [
    { title: "Apna College", url: "https://www.youtube.com/watch?v=ESnrn1kAD4E&ab_channel=ApnaCollege" },
    { title: "SuperSimpleDev (Highly Recommended)", url: "https://www.youtube.com/watch?v=G3e-cpL7ofc&t=1062s&ab_channel=SuperSimpleDev" },
    { title: "PW Skills Tech", url: "https://www.youtube.com/watch?v=WuiB5TAQOAM&ab_channel=PWSkillsTech" },
    { title: "SuperSimpleDev", url: "https://www.youtube.com/watch?v=OXGznpKZ_sA&ab_channel=freeCodeCamp.org" },
    { title: "Bro Code", url: "https://www.youtube.com/watch?v=HGTJBPNC-Gw&ab_channel=BroCode" },
    { title: "FreeCodeCamp", url: "https://www.youtube.com/watch?v=1Rs2ND1ryYc&ab_channel=freeCodeCamp.org" },
    { title: "Thapa Technical (Recommended)", url: "https://www.youtube.com/watch?v=MSICFljRcb4&t=23300s&ab_channel=ThapaTechnical" },
    { title: "Anuj Bhaiya (TailWind CSS)", url: "https://www.youtube.com/watch?v=mGN9-FPsX9o&t=1043s&ab_channel=AnujBhaiya" },
    { title: "Apna College (Recommended)", url: "https://www.youtube.com/watch?v=nGhKIC_7Mkk&ab_channel=ApnaCollege" },
    { title: "Ws Cube Tech (TailWind CSS)", url: "https://www.youtube.com/watch?v=Sae1MD5E5p8&ab_channel=WsCubeTech" }
  ];

  return (
    <>
      <h1 className="html_yt_heading">
        These are the <strong style={{ textDecoration: 'underline', color: 'blue' }}>Top 10</strong> Youtube Playlists That You Can Refer
      </h1>

      <h4 className="des_yt_html">
        1. Dive Into The Main Concepts <br />
        2. Animation Explanations with Real-World Examples <br />
        3. Important with Note Clarification.
      </h4>

      {videos.map((video, index) => (
        <div key={index} className="container_html_yt_links">
          <p className="vid">
            {index + 1}. {video.title}
            <button
              style={{
                marginLeft: '200px',
                padding: '7px',
                background: 'black',
                color: 'white',
                borderRadius: '8px'
              }}
              onClick={() => window.open(video.url, "_blank")}
            >
              Click Me
            </button>
          </p>
        </div>
      ))}
    </>
  );
}

export default CssYt;
